module.exports = __webpack_public_path__ + "img/deliver-green.e571e6d5.svg";